import { envVars } from './envVars';

const getValueOrDefault = (value: string, defaultValue: string): string => {
	return new RegExp('%%%\\w+%%%').test(value) ? defaultValue : value;
};

export const ApiConfig = {
	headers: {
		accept: getValueOrDefault(envVars.api.headers.accept, 'application/vnd.mbcpcjIziBizi+json; version=3.001.000'),
		'ocp-apim-subscription-key': getValueOrDefault(
			envVars.api.headers['ocp-apim-subscription-key'],
			'536285b3e29b4bcf9702f6e74fb572e8'
		),
		'content-type': getValueOrDefault(envVars.api.headers['content-type'], 'application/json'),
	},
	url: getValueOrDefault(envVars.api.url, 'https://mbcplab.azure-api.net/cj/IziBizi/'),
};

export const LoggerConfig = {
	debug: getValueOrDefault(envVars.logger.debug, 'true') === 'true',
	error: getValueOrDefault(envVars.logger.error, 'true') === 'true',
	log: getValueOrDefault(envVars.logger.log, 'true') === 'true',
};
